import React, { useState, useEffect } from "react";
import { db, storage } from "../../utils/firebase";
import { collection, getDocs, doc, updateDoc, deleteDoc } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Navbar from "../navbar/Navbar";
import Footer from "../footer/Footer";
import './AdminUsers.css';
import { Link, useLocation } from 'react-router-dom';


const ShoppingAdmin = () => {
  const [bridgesData, setBridgesData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingBridge, setEditingBridge] = useState(null);
  const [newImages, setNewImages] = useState({});
  const location = useLocation();

  useEffect(() => {
    const fetchBridgesData = async () => {
      try {
        const bridgesCollectionRef = collection(db, "shopping_market");
        const snapshot = await getDocs(bridgesCollectionRef);

        if (!snapshot.empty) {
          const data = snapshot.docs.map(async (doc) => {
            const docData = doc.data();

            const imageUrls = await Promise.all([
              docData.images_1,
              docData.images_2,
              docData.images_3,
              docData.images_4,
              docData.images_bg
            ].map(async (imagePath) => {
              if (imagePath) {
                const imageRef = ref(storage, imagePath);
                try {
                  const url = await getDownloadURL(imageRef);
                  return url;
                } catch (error) {
                  console.error("Error fetching image URL for path:", imagePath, error);
                  return null;
                }
              }
              return null;
            }));

            return { id: doc.id, ...docData, imageUrls };
          });

          const bridgesDataWithImages = await Promise.all(data);
          setBridgesData(bridgesDataWithImages);
        } else {
          console.log("No bridges data found in the database.");
        }
      } catch (error) {
        console.error("Error fetching bridges data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchBridgesData();
  }, []);

  // Handle Edit button click
  const handleEditClick = (bridge) => {
    setEditingBridge({ ...bridge }); // Make a copy of the bridge data
  };


  // Handle image uploads
  const handleImageChange = (e, index) => {
    setNewImages((prevState) => ({
      ...prevState,
      [index]: e.target.files[0],
    }));
  };
  
  const handleFormSubmit = async (e) => {
    e.preventDefault();
  
    if (!editingBridge) return;
  
    const { id, title, barangay, description } = editingBridge;
  
    // Prepare updated data for text fields
    const updatedData = {
      ...(title && { title }),
      ...(barangay && { barangay }),
      ...(description && { description }),
    };
  
    // Upload new images and update URLs
    const updatedImages = {};
  
    for (const [index, imageFile] of Object.entries(newImages)) {
      if (imageFile) {
        const fileExtension = imageFile.name.split(".").pop();
        const imageRef = ref(storage, `places/${index}${id}.${fileExtension}`);
        await uploadBytes(imageRef, imageFile);
        const imageUrl = await getDownloadURL(imageRef);
 // Map to Firestore fields
      }
    }
    // Merge updated text data and images
    const finalUpdateData = {
      ...updatedData,
      ...updatedImages, // Only include new image data if uploaded
    };
  
    // Update Firestore document
    const bridgeDocRef = doc(db, "shopping_market", id);
    await updateDoc(bridgeDocRef, finalUpdateData);
  
    // Update local state
    const updatedBridgesData = bridgesData.map((bridge) => {
      if (bridge.id === id) {
        return {
          ...bridge,
          ...updatedData,
          imageUrls: {
            ...bridge.imageUrls,
            ...Object.values(updatedImages), 
          },
        };
      }
      return bridge;
    });
  
    setBridgesData(updatedBridgesData);
    setEditingBridge(null); // Close the edit form
    setNewImages({}); // Reset image state
  };
  
  
  

  // Cancel Edit
  const handleCancelEdit = () => {
    setEditingBridge(null); // Close the edit form without saving
  };

  if (loading) return <p>Loading data...</p>;

  return (
    <div className="admin-page">
      <Navbar />
      <div className="admin-container">
      <div className="admin-sidebar">

          <h2>Admin Panel</h2>
          <Link to="/adminusers" className={`sidebar-button ${location.pathname === '/adminusers' ? 'active' : ''}`}>Users</Link>
          <Link to="/adminposts" className={`sidebar-button ${location.pathname === '/adminposts' ? 'active' : ''}`}>User Posts</Link>
          <Link to="/adminfeedback" className={`sidebar-button ${location.pathname === '/adminfeedback' ? 'active' : ''}`}>User Feedback</Link>
          <Link to="/announcementadmin" className={`sidebar-button ${location.pathname === '/announcementadmin' ? 'active' : ''}`}>Announcements</Link>
          <Link to="/exploreaboutadmin" className={`sidebar-button ${location.pathname === '/exploreaboutadmin' ? 'active' : ''}`}>Explore about Bacoor</Link>

          <h2>Places to Visit</h2>
          <Link to="/bridgesadmin" className={`sidebar-button ${location.pathname === '/bridgesadmin' ? 'active' : ''}`}>Bridges & Dams</Link>
          <Link to="/monumentsadmin" className={`sidebar-button ${location.pathname === '/monumentsadmin' ? 'active' : ''}`}>Monuments & Statues</Link>
          <Link to="/houseadmin" className={`sidebar-button ${location.pathname === '/houseadmin' ? 'active' : ''}`}>Ancestral Houses</Link>
          <Link to="/churchesadmin" className={`sidebar-button ${location.pathname === '/churchesadmin' ? 'active' : ''}`}>Churches & Religious Sites</Link>

          <h2>Things to Do</h2>
          <Link to="/recreationaladmin" className={`sidebar-button ${location.pathname === '/recreationaladmin' ? 'active' : ''}`}>Recreational Activities</Link>
          <Link to="/diningadmin" className={`sidebar-button ${location.pathname === '/diningadmin' ? 'active' : ''}`}>Dining and Culinary</Link>
          <Link to="/shoppingadmin" className={`sidebar-button ${location.pathname === '/shoppingadmin' ? 'active' : ''}`}>Shopping and Market</Link>

          <h2>Archives</h2>
          <Link to="/userarchive" className={`sidebar-button ${location.pathname === '/userarchive' ? 'active' : ''}`}>Users</Link>
          <Link to="/postsarchive" className={`sidebar-button ${location.pathname === '/postsarchive' ? 'active' : ''}`}>Posts</Link>
          <Link to="/feedbackarchive" className={`sidebar-button ${location.pathname === '/feedbackarchive' ? 'active' : ''}`}>Feedback</Link>
          <Link to="/announcementarchive" className={`sidebar-button ${location.pathname === '/announcementarchive' ? 'active' : ''}`}>Announcements</Link>
        </div>

        <div className="admin-content">
          <h2>Shopping and Market Management</h2>
          <div className="table-container">
            <table className="bridges-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Barangay</th>
                  <th>Description</th>
                  <th>Image 1</th>
                  <th>Image 2</th>
                  <th>Image 3</th>
                  <th>Image 4</th>
                  <th>Background Image</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {bridgesData.map((bridge) => (
                  <tr key={bridge.id}>
                    <td>
                    {editingBridge && editingBridge.id === bridge.id ? (
                        <input
                        type="text"
                        value={editingBridge.title}
                        onChange={(e) => setEditingBridge({ ...editingBridge, title: e.target.value })}
                        style={{
                            width: "150px",
                            boxSizing: "border-box",
                        }}
                        />
                    ) : (
                        bridge.title
                    )}
                    </td>
                    <td>
                      {editingBridge && editingBridge.id === bridge.id ? (
                        <input
                          type="text"
                          value={editingBridge.barangay}
                          onChange={(e) => setEditingBridge({ ...editingBridge, barangay: e.target.value })}
                          style={{
                            width: "200px",
                            boxSizing: "border-box",
                        }}
                        />
                      ) : (
                        bridge.barangay
                      )}
                    </td>
                    <td>
                      {editingBridge && editingBridge.id === bridge.id ? (
                        <textarea
                          value={editingBridge.description}
                          onChange={(e) => setEditingBridge({ ...editingBridge, description: e.target.value })}
                          style={{
                            width: "300px",
                            height: "300px",
                            boxSizing: "border-box",
                        }}
                        />
                      ) : (
                        bridge.description
                      )}
                    </td>
                    <td>
                      {editingBridge && editingBridge.id === bridge.id ? (
                        <input
                          type="file"
                          onChange={(e) => handleImageChange(e, "1")}
                          style={{
                            width: "200px",
                            boxSizing: "border-box",
                        }}
                        />
                      ) : (
                        bridge.imageUrls[0] && <img src={bridge.imageUrls[0]} alt="Image 1" style={{ width: "50px", height: "50px", margin: "5px", borderRadius: "8px" }} />
                      )}
                    </td>
                    <td>
                      {editingBridge && editingBridge.id === bridge.id ? (
                        <input
                          type="file"
                          onChange={(e) => handleImageChange(e, "2")}
                          style={{
                            width: "200px",
                            boxSizing: "border-box",
                        }}
                        />
                      ) : (
                        bridge.imageUrls[1] && <img src={bridge.imageUrls[1]} alt="Image 2" style={{ width: "50px", height: "50px", margin: "5px", borderRadius: "8px" }} />
                      )}
                    </td>
                    <td>
                      {editingBridge && editingBridge.id === bridge.id ? (
                        <input
                          type="file"
                          onChange={(e) => handleImageChange(e, "3")}
                          style={{
                            width: "200px",
                            boxSizing: "border-box",
                        }}
                        />
                      ) : (
                        bridge.imageUrls[2] && <img src={bridge.imageUrls[2]} alt="Image 3" style={{ width: "50px", height: "50px", margin: "5px", borderRadius: "8px" }} />
                      )}
                    </td>
                    <td>
                      {editingBridge && editingBridge.id === bridge.id ? (
                        <input
                          type="file"
                          onChange={(e) => handleImageChange(e, "4")}
                          style={{
                            width: "200px",
                            boxSizing: "border-box",
                        }}
                        />
                      ) : (
                        bridge.imageUrls[3] && <img src={bridge.imageUrls[3]} alt="Image 4" style={{ width: "50px", height: "50px", margin: "5px", borderRadius: "8px" }} />
                      )}
                    </td>
                    <td>
                      {editingBridge && editingBridge.id === bridge.id ? (
                        <input
                          type="file"
                          onChange={(e) => handleImageChange(e, "bg")}
                          style={{
                            width: "200px",
                            boxSizing: "border-box",
                        }}
                        />
                      ) : (
                        bridge.imageUrls[4] && <img src={bridge.imageUrls[4]} alt="Background" style={{ width: "50px", height: "50px", margin: "5px", borderRadius: "8px" }} />
                      )}
                    </td>
                    <td>
                    {editingBridge && editingBridge.id === bridge.id ? (
                      <>
                        <button
                          className="save-btn btn btn-success"
                          onClick={handleFormSubmit}
                        >
                          <i className="bi bi-check"></i>
                        </button>
                        <button
                          className="cancel-btn btn btn-secondary"
                          onClick={handleCancelEdit}
                        >
                          <i className="bi bi-x"></i>
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          className="edit-btn btn btn-primary"
                          onClick={() => handleEditClick(bridge)}
                        >
                          <i className="bi bi-pencil"></i>
                        </button>
                      </>
                    )}
                  </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ShoppingAdmin;
